import LabelMixin from '~/mixins/label'

export default {
    mixins: [LabelMixin],

    props: {
        placeholder: {
            type: String,
            required: false,
        },
        value: {
            type: null,
        },
        error: {
            type: String,
            default: null,
        },
    },
    created: function () {
        this.model = this.value;
    },
    watch: {
        model: function(newValue, oldValue) {
            this.$emit('input', newValue)
        }
    },
    data() {
        return {
            model: null,
        }
    },
}